import React from 'react'
import { getLastDocumentFromPatientId } from '../ducks'
import { getFhirResourceId, getRole } from '@medeo/user'
import { connect } from 'react-redux'

const WeeklyReportAlert = ({ lastDocumentDate, role }) => {
  const todayDate = new Date()
  const documentDate = new Date(lastDocumentDate)
  const timeDiffInWeeks =
    (todayDate.getTime() - documentDate.getTime()) / (1000 * 60 * 60 * 24 * 7)

  return role === 'practitioner' ? (
    timeDiffInWeeks > 1 ? (
      <p style={{ backgroundColor: 'red', color: 'white' }}>
        La dernière revue date d'il y a plus d'une semaine
      </p>
    ) : null
  ) : timeDiffInWeeks > 12 ? (
    <p style={{ backgroundColor: 'red', color: 'white' }}>
      La dernière revue date d'il y a plus de trois mois
    </p>
  ) : null
}

const mapStateToProps = (state, ownProps) => {
  const fhirResourceId = getFhirResourceId(state)

  const document = getLastDocumentFromPatientId(
    state,
    ownProps.patient,
    fhirResourceId
  )
  const role = getRole(state)
  return {
    lastDocumentDate: document ? document.created : new Date().toDateString(),
    role
  }
}

export default connect(mapStateToProps)(WeeklyReportAlert)



// WEBPACK FOOTER //
// ./src/Documents/containers/WeeklyReportAlert.js